/* Ayudate · Catálogo de cursos de la Universidad de Costa Rica
   ─────────────────────────────────────────────────────────────────────────
   La lista de abajo es la de los cursos que se piden para tutoría en la UCR,
   no el catálogo completo de la universidad. Las siglas y los nombres salen
   de la Guía de Cursos y Horarios oficial de la Oficina de Registro e
   Información (ORI-UCR), Ciudad Universitaria Rodrigo Facio, I Ciclo 2026
   (semestral ordinaria):

     https://ori.ucr.ac.cr/sites/default/files/archivos-2026/\
     guia_horarios_ciudad_universitaria_rodrigo_facio_1-2026_semestral-ordinaria_v1.pdf

   Alcance y criterios, para que se sepa qué esperar de esta lista:

   · Solo cursos de GRADO, y de ellos solo los que se tutoran de verdad: los
     de servicio y los de tronco común de cada carrera, que son los que se
     repiten y se arrastran. Quedan fuera los cursos de especialidad de
     último año, los laboratorios (la tutoría es de la teoría, no de la
     práctica), los proyectos, seminarios, prácticas y trabajos finales.
   · Un área por unidad académica (escuela o carrera), no por las áreas
     académicas de la UCR: "Ciencias Básicas" o "Ingeniería" completas darían
     listas de cientos de cursos imposibles de recorrer. El orden en el que
     van abajo sí sigue esas áreas: Básicas, Ingeniería, Salud y Sociales.
   · Solo las carreras cuyos cursos se tutoran. Fuera quedan Artes y Letras,
     las Agroalimentarias, los Estudios Generales, Derecho, las escuelas de
     ciencias sociales sin curso tutorable y las carreras cuya tutoría no se
     pide (Geología, Arquitectura, las ingenierías de Biosistemas,
     Topográfica e Industrial, Enfermería, Nutrición, Odontología,
     Administración Pública y Ciencias Políticas). La Escuela de Química sí
     tiene área propia desde que se pidieron sus doce cursos: antes solo se
     tutoraban Química Orgánica I y II, y vivían prestados dentro de
     Farmacia, que era quien los pedía. Volvieron a su escuela, y con las
     siglas QU-0200 y QU-0202 de la lista pedida, no las QU-0244 y QU-0254
     con que estaban en Farmacia.

   `grupo` es a cuál de las áreas académicas de la UCR pertenece cada área de
   estas. No lo usa el buscador público (donde las áreas van en una sola
   cuadrícula, ya ordenadas por grupo), sino los <select> del panel del tutor,
   que sin encabezados obligarían a recorrer diecisiete opciones a ciegas.

   Los códigos van con guion — MA-1001, B-0106 — que es como los escribe la
   UCR y, de paso, es lo que los mantiene separados de los del Tec, que van
   sin guion (MA1102). Sin esa diferencia, códigos como IC1802 (Introducción
   a la Programación en el Tec) e IC-1802 (Ingeniería Civil en la UCR) se
   pisarían dentro del catálogo CURSO de areas.js, que indexa por código. El
   buscador ignora el guion al comparar (ver lib/buscar.js), así que quien
   escriba "ma1001" igual encuentra MA-1001.

   · Algunos cursos que se piden para tutoría no abren en el ciclo de la guía
     ni traen sigla en el plan que se consultó. Van SIN CÓDIGO, con el nombre
     de identificador, que es lo que areas.js hace con los idiomas y con las
     materias de colegio (ver CURSO y `sinCodigo` allá). Son estos, y hay que
     ponerles la sigla cuando aparezca: en Ingeniería Civil, Análisis
     Estructural II, Mecánica de Suelos I, Hidráulica y Diseño Geométrico de
     Carreteras; en Ciencias Actuariales, Matemática Financiera, Contingencias
     de Vida II, Microeconomía, Macroeconomía y Análisis de Series de Tiempo;
     en Farmacia, Química Farmacéutica y Farmacología I y II; en Economía,
     Teoría Macroeconómica II y Econometría II; en Dirección de Empresas,
     Contabilidad Financiera I y II; y en Contaduría, Auditoría Financiera II
     y Contabilidad Avanzada II.
   · Dos nombres se numeraron a mano porque la guía deja sin número la primera
     mitad de un par que sí numera en la segunda: IM-0400 "Elementos de
     Máquinas I" (por IM-0407 II) e IC-0701 "Análisis Estructural I" (por el
     Análisis Estructural II de arriba). Los códigos no se tocaron.

   Para regenerarlo: descargar la guía del ciclo nuevo y volver a extraer, y
   repasar los agregados a mano de arriba, que la guía no los trae.  */

const C = "#06B6D4";

export const AREAS_UCR = [
  {
    id: "ucr-mate", nombre: "Matemática", grupo: "Ciencias Básicas", color: C,
    cursos: [
      { cod: "MA-0001", nom: "Precálculo" },
      { cod: "MA-0250", nom: "Cálculo en una Variable I" },
      { cod: "MA-0350", nom: "Cálculo en una Variable II" },
      { cod: "MA-0360", nom: "Álgebra Lineal I" },
      { cod: "MA-0450", nom: "Cálculo en Varias Variables" },
      { cod: "MA-0455", nom: "Ecuaciones Diferenciales Ordinarias" },
      { cod: "MA-0460", nom: "Álgebra Lineal II" },
      { cod: "MA-0505", nom: "Análisis I" },
      { cod: "MA-0540", nom: "Principios de Análisis I" },
      { cod: "MA-0552", nom: "Introducción a la Topología" },
      { cod: "MA-0561", nom: "Grupos y Anillos" },
      { cod: "MA-0702", nom: "Variable Compleja I" },
      { cod: "MA-1001", nom: "Cálculo I" },
      { cod: "MA-1002", nom: "Cálculo II" },
      { cod: "MA-1003", nom: "Cálculo III" },
      { cod: "MA-1004", nom: "Álgebra Lineal" },
      { cod: "MA-1005", nom: "Ecuaciones Diferenciales" },
      { cod: "MA-1006", nom: "Introducción al Análisis Numérico" },
      { cod: "MA-1023", nom: "Cálculo con Optimización" },
      { cod: "MA-1030", nom: "Introducción a la Probabilidad" },
      { cod: "MA-2210", nom: "Ecuaciones Diferenciales Aplicadas" },
    ],
  },
  {
    id: "ucr-actuariales", nombre: "Ciencias Actuariales", grupo: "Ciencias Básicas", color: C,
    cursos: [
      { cod: "CA-0151", nom: "Cálculo Diferencial e Integral I" },
      { cod: "CA-0251", nom: "Cálculo Diferencial e Integral II" },
      { cod: "CA-0252", nom: "Álgebra Lineal" },
      { cod: "CA-0306", nom: "Contingencias de Vida I" },
      { cod: "CA-0351", nom: "Cálculo Diferencial e Integral en Varias Variables" },
      { cod: "CA-0352", nom: "Introducción al Análisis Matemático en una Variable" },
      { cod: "CA-0412", nom: "Pensiones I" },
      { cod: "CA-0413", nom: "Seguros de No-Vida I" },
      { cod: "CA-0414", nom: "Modelos Lineales y de Sobrevivencia" },
      { cod: "CA-0721", nom: "Probabilidad" },
      { cod: "CA-0821", nom: "Procesos Estocásticos" },
      { nom: "Matemática Financiera (Teoría del Interés)" },
      { nom: "Contingencias de Vida II" },
      { nom: "Microeconomía" },
      { nom: "Macroeconomía" },
      { nom: "Análisis de Series de Tiempo" },
    ],
  },
  {
    id: "ucr-fisica", nombre: "Física", grupo: "Ciencias Básicas", color: C,
    cursos: [
      { cod: "FS-0103", nom: "Física para Ciencias de la Vida I" },
      { cod: "FS-0132", nom: "Física Aplicada a Farmacia" },
      { cod: "FS-0208", nom: "Física para Ciencias Médicas" },
      { cod: "FS-0210", nom: "Física General I" },
      { cod: "FS-0227", nom: "Física General para Físicos I" },
      { cod: "FS-0230", nom: "Física I" },
      { cod: "FS-0310", nom: "Física General II" },
      { cod: "FS-0327", nom: "Física General para Físicos II" },
      { cod: "FS-0330", nom: "Física II" },
      { cod: "FS-0408", nom: "Termodinámica" },
      { cod: "FS-0409", nom: "Métodos Matemáticos de Física I" },
      { cod: "FS-0410", nom: "Física General III" },
      { cod: "FS-0427", nom: "Física General para Físicos III" },
      { cod: "FS-0430", nom: "Física III" },
      { cod: "FS-0515", nom: "Mecánica Teórica I" },
      { cod: "FS-0516", nom: "Métodos Matemáticos de Física II" },
      { cod: "FS-0527", nom: "Física General para Físicos IV" },
      { cod: "FS-0616", nom: "Métodos Matemáticos de Física III" },
      { cod: "FS-0617", nom: "Física Estadística" },
      { cod: "FS-0619", nom: "Mecánica Teórica II" },
      { cod: "FS-0717", nom: "Mecánica Cuántica I" },
      { cod: "FS-0718", nom: "Electromagnetismo I" },
      { cod: "FS-0819", nom: "Mecánica Cuántica II" },
      { cod: "FS-0820", nom: "Electromagnetismo II" },
    ],
  },
  {
    id: "ucr-biologia", nombre: "Biología", grupo: "Ciencias Básicas", color: C,
    cursos: [
      { cod: "B-0106", nom: "Biología General" },
      { cod: "B-0111", nom: "Botánica Agrícola I" },
      { cod: "B-0116", nom: "Genética para Zootecnia" },
      { cod: "B-0160", nom: "Introducción a la Biología I" },
      { cod: "B-0216", nom: "Zoología I" },
      { cod: "B-0237", nom: "Botánica I" },
      { cod: "B-0345", nom: "Genética General" },
      { cod: "B-0411", nom: "Anatomía Comparada" },
      { cod: "B-0442", nom: "Introducción a la Fisiología Vegetal" },
      { cod: "B-0452", nom: "Genética de Poblaciones" },
      { cod: "B-0453", nom: "Citogenética Humana I" },
      { cod: "B-0470", nom: "Biología Celular y Molecular" },
    ],
  },
  {
    id: "ucr-quimica", nombre: "Química", grupo: "Ciencias Básicas", color: C,
    cursos: [
      { cod: "QU-0100", nom: "Química General I" },
      { cod: "QU-0102", nom: "Química General II" },
      { cod: "QU-0106", nom: "Fundamentos de Química" },
      { cod: "QU-0200", nom: "Química Orgánica I" },
      { cod: "QU-0202", nom: "Química Orgánica II" },
      { cod: "QU-0208", nom: "Química Bio-Orgánica" },
      { cod: "QU-0210", nom: "Química Analítica General" },
      { cod: "QU-0211", nom: "Fundamentos de Química Analítica Cuantitativa" },
      { cod: "QU-0310", nom: "Fisicoquímica I" },
      { cod: "QU-0311", nom: "Fisicoquímica II" },
      { cod: "QU-0401", nom: "Química Inorgánica I" },
      { cod: "QU-0410", nom: "Análisis Instrumental I" },
    ],
  },
  {
    id: "ucr-compu", nombre: "Computación e Informática", grupo: "Ingeniería", color: C,
    cursos: [
      { cod: "CI-0108", nom: "Computación para Economistas" },
      { cod: "CI-0111", nom: "Estructuras Discretas" },
      { cod: "CI-0112", nom: "Programación I" },
      { cod: "CI-0113", nom: "Programación II" },
      { cod: "CI-0116", nom: "Análisis de Algoritmos y Estructuras de Datos" },
      { cod: "CI-0117", nom: "Programación Paralela y Concurrente" },
      { cod: "CI-0118", nom: "Lenguaje Ensamblador" },
      { cod: "CI-0120", nom: "Arquitectura de Computadoras" },
      { cod: "CI-0122", nom: "Sistemas Operativos" },
      { cod: "CI-0124", nom: "Computabilidad y Complejidad" },
      { cod: "CI-0130", nom: "Métodos de Modelado y Optimización" },
      { cod: "CI-0202", nom: "Principios de Informática" },
    ],
  },
  {
    id: "ucr-ing-electrica", nombre: "Ingeniería Eléctrica", grupo: "Ingeniería", color: C,
    cursos: [
      { cod: "IE-0209", nom: "Circuitos Lineales I" },
      { cod: "IE-0247", nom: "Señales y Sistemas I" },
      { cod: "IE-0307", nom: "Electromagnetismo I" },
      { cod: "IE-0309", nom: "Circuitos Lineales II" },
      { cod: "IE-0313", nom: "Electrónica I" },
      { cod: "IE-0315", nom: "Máquinas Eléctricas I" },
      { cod: "IE-0323", nom: "Sistemas Digitales I" },
      { cod: "IE-0347", nom: "Señales y Sistemas II" },
      { cod: "IE-0405", nom: "Modelos Probabilísticos de Señales y Sistemas" },
      { cod: "IE-0413", nom: "Electrónica II" },
      { cod: "IE-0431", nom: "Sistemas de Control" },
      { cod: "IE-0469", nom: "Sistemas de Potencia I" },
      { cod: "IE-0623", nom: "Microprocesadores" },
    ],
  },
  {
    id: "ucr-ing-civil", nombre: "Ingeniería Civil", grupo: "Ingeniería", color: C,
    cursos: [
      { cod: "IC-0302", nom: "Diseño Gráfico" },
      { cod: "IC-0401", nom: "Estática" },
      { cod: "IC-0510", nom: "Mecánica del Sólido I" },
      { cod: "IC-0605", nom: "Mecánica de Fluidos" },
      { cod: "IC-0610", nom: "Mecánica del Sólido II" },
      { cod: "IC-0701", nom: "Análisis Estructural I" },
      { nom: "Análisis Estructural II" },
      { nom: "Mecánica de Suelos I" },
      { nom: "Hidráulica (Sistemas de Tuberías y Canales)" },
      { nom: "Diseño Geométrico de Carreteras" },
    ],
  },
  {
    id: "ucr-ing-mecanica", nombre: "Ingeniería Mecánica", grupo: "Ingeniería", color: C,
    cursos: [
      { cod: "IM-0207", nom: "Mecánica I" },
      { cod: "IM-0300", nom: "Análisis de Sistemas" },
      { cod: "IM-0305", nom: "Transferencia de Calor" },
      { cod: "IM-0307", nom: "Mecánica II" },
      { cod: "IM-0313", nom: "Termodinámica I" },
      { cod: "IM-0315", nom: "Mecánica del Sólido I" },
      { cod: "IM-0329", nom: "Diseño de Mecanismos" },
      { cod: "IM-0400", nom: "Elementos de Máquinas I" },
      { cod: "IM-0407", nom: "Elementos de Máquinas II" },
      { cod: "IM-0413", nom: "Termodinámica II" },
      { cod: "IM-0415", nom: "Mecánica del Sólido II" },
      { cod: "IM-0423", nom: "Mecánica de Fluidos" },
      { cod: "IM-0429", nom: "Dinámica de Máquinas" },
      { cod: "IM-0729", nom: "Vibraciones" },
    ],
  },
  {
    id: "ucr-ing-quimica", nombre: "Ingeniería Química", grupo: "Ingeniería", color: C,
    cursos: [
      { cod: "IQ-0313", nom: "Fenómenos de Transferencia" },
      { cod: "IQ-0332", nom: "Análisis de Procesos I" },
      { cod: "IQ-0333", nom: "Análisis de Procesos II" },
      { cod: "IQ-0334", nom: "Termodinámica I" },
      { cod: "IQ-0335", nom: "Termodinámica II" },
      { cod: "IQ-0416", nom: "Cinética y Reactores Químicos" },
      { cod: "IQ-0423", nom: "Operaciones de Transferencia de Fluidos y Calor" },
      { cod: "IQ-0424", nom: "Operaciones por Separación de Fases" },
      { cod: "IQ-0517", nom: "Control e Instrumentación de Procesos" },
      { cod: "IQ-0525", nom: "Operaciones de Separación por Métodos Difusionales" },
    ],
  },
  {
    id: "ucr-medicina", nombre: "Medicina", grupo: "Salud", color: C,
    cursos: [
      { cod: "ME-0117", nom: "Bioquímica para Medicina" },
      { cod: "ME-0306", nom: "Farmacología Básica I" },
      { cod: "ME-0308", nom: "Farmacología Clínica I" },
      { cod: "ME-0411", nom: "Histología" },
      { cod: "ME-0412", nom: "Anatomía Descriptiva" },
      { cod: "ME-2012", nom: "Fisiología" },
      { cod: "ME-3103", nom: "Fisiopatología y Semiología" },
      { cod: "MF-0140", nom: "Elementos de Fisiología Humana" },
      { cod: "MF-1000", nom: "Fisiología Humana" },
      { cod: "MF-2009", nom: "Principios de Fisiología Humana" },
      { cod: "MN-0105", nom: "Anatomía Humana" },
      { cod: "MN-0107", nom: "Anatomía Neuromusculoesquelética Integral" },
      { cod: "MN-0116", nom: "Histología (Nutrición)" },
      { cod: "MN-0220", nom: "Anatomía Macroscópica" },
      { cod: "MQ-0200", nom: "Bioquímica para Enfermería" },
      { cod: "MQ-0207", nom: "Bioquímica para Fisioterapia" },
      { cod: "MQ-0208", nom: "Bioquímica para Farmacia" },
      { cod: "MQ-0310", nom: "Bioquímica Dental" },
      { cod: "MQ-0320", nom: "Bioquímica para Agronomía" },
      { cod: "MQ-0329", nom: "Bioquímica para Tecnología de Alimentos" },
      { cod: "MQ-0335", nom: "Bioquímica para Nutrición" },
    ],
  },
  {
    id: "ucr-farmacia", nombre: "Farmacia", grupo: "Salud", color: C,
    cursos: [
      { cod: "FA-0218", nom: "Análisis de Medicamentos I" },
      { cod: "FA-0222", nom: "Análisis de Medicamentos II" },
      { cod: "FA-0227", nom: "Análisis de Medicamentos III" },
      { cod: "FA-0335", nom: "Fisicoquímica Farmacéutica I" },
      { cod: "FA-0336", nom: "Fisicoquímica Farmacéutica II" },
      { cod: "FA-0338", nom: "Biofarmacia y Farmacocinética" },
      { nom: "Química Farmacéutica (Medicinal)" },
      { nom: "Farmacología I" },
      { nom: "Farmacología II" },
    ],
  },
  {
    id: "ucr-microbiologia", nombre: "Microbiología", grupo: "Salud", color: C,
    cursos: [
      { cod: "MB-0210", nom: "Técnicas de Biología Celular y Molecular" },
      { cod: "MB-0211", nom: "Bacteriología Médica" },
      { cod: "MB-3000", nom: "Genómica Clínica y Diagnóstica" },
      { cod: "MB-4002", nom: "Inmunología Clínica" },
      { cod: "MC-0201", nom: "Fundamentos de Hematología" },
      { cod: "MC-4008", nom: "Inmunohematología" },
      { cod: "MC-5000", nom: "Química Clínica" },
      { cod: "MP-1042", nom: "Protozoología Médica" },
      { cod: "MP-3404", nom: "Parasitología General" },
    ],
  },
  {
    id: "ucr-economia", nombre: "Economía", grupo: "Ciencias Sociales", color: C,
    cursos: [
      { cod: "EC-2100", nom: "Teoría Microeconómica 1" },
      { cod: "EC-2200", nom: "Teoría Microeconómica 2" },
      { cod: "EC-2201", nom: "Teoría de Juegos e Información" },
      { cod: "EC-2301", nom: "Economía Financiera" },
      { cod: "EC-3200", nom: "Teoría Macroeconómica I" },
      { cod: "EC-3300", nom: "Crecimiento y Ciclos" },
      { cod: "EC-4200", nom: "Econometría" },
      { nom: "Teoría Macroeconómica II" },
      { nom: "Econometría II (Series de Tiempo)" },
    ],
  },
  {
    id: "ucr-empresas", nombre: "Dirección de Empresas", grupo: "Ciencias Sociales", color: C,
    cursos: [
      { cod: "DN-0105", nom: "Métodos Cuantitativos para la Toma de Decisiones I" },
      { cod: "DN-0110", nom: "Métodos Cuantitativos para la Toma de Decisiones II" },
      { cod: "DN-0122", nom: "Valoraciones, Fusiones y Adquisiciones de Empresas" },
      { cod: "DN-0124", nom: "Costeo Gerencial para Administradores" },
      { cod: "DN-0340", nom: "Administración Financiera I" },
      { cod: "DN-0341", nom: "Administración Financiera II" },
      { cod: "DN-0423", nom: "Investigación de Mercados" },
      { cod: "DN-0442", nom: "Administración Financiera III" },
      { cod: "DN-0496", nom: "Gerencia de Operaciones" },
      { cod: "DN-0548", nom: "Mercados Financieros Internacionales" },
      { nom: "Contabilidad Financiera I" },
      { nom: "Contabilidad Financiera II" },
    ],
  },
  {
    id: "ucr-contaduria", nombre: "Contaduría Pública", grupo: "Ciencias Sociales", color: C,
    cursos: [
      { cod: "PC-0200", nom: "Contabilidad Básica" },
      { cod: "PC-0202", nom: "Contabilidad Intermedia I" },
      { cod: "PC-0208", nom: "Costos Avanzados" },
      { cod: "PC-0240", nom: "Matemática Financiera" },
      { cod: "PC-0304", nom: "Contabilidad Intermedia II" },
      { cod: "PC-0306", nom: "Sistemas de Costeo Básico" },
      { cod: "PC-0320", nom: "Auditoría Financiera I" },
      { cod: "PC-0344", nom: "Formulación y Evaluación de Proyectos I" },
      { cod: "PC-0407", nom: "Contabilidad Avanzada I" },
      { cod: "PC-0462", nom: "Legislación Tributaria y Aduanera" },
      { nom: "Auditoría Financiera II" },
      { nom: "Contabilidad Avanzada II" },
    ],
  },
  {
    id: "ucr-estadistica", nombre: "Estadística", grupo: "Ciencias Sociales", color: C,
    cursos: [
      { cod: "XS-0100", nom: "Fundamentos de Teoría Estadística" },
      { cod: "XS-0122", nom: "Modelos Probabilísticos I" },
      { cod: "XS-0125", nom: "Modelos Lineales Avanzados" },
      { cod: "XS-0126", nom: "Minería de Datos y Análisis Multivariado" },
      { cod: "XS-0128", nom: "Inferencia Bayesiana" },
      { cod: "XS-0129", nom: "Programación para Estadística I" },
      { cod: "XS-0215", nom: "Estadística para Biociencias" },
      { cod: "XS-0217", nom: "Probabilidades e Inferencia Estadística" },
      { cod: "XS-0276", nom: "Estadística General I" },
      { cod: "XS-0277", nom: "Estadística General II" },
      { cod: "XS-0341", nom: "Estadística I para Ciencias Sociales" },
      { cod: "XS-0342", nom: "Estadística II para Ciencias Sociales" },
      { cod: "XS-2130", nom: "Modelos de Regresión Aplicados" },
      { cod: "XS-3110", nom: "Diseños de Muestreo Probabilístico" },
      { cod: "XS-3150", nom: "Diseño de Experimentos" },
      { cod: "XS-3310", nom: "Teoría Estadística" },
    ],
  },
];

/* Ids de las áreas de arriba, en el mismo orden, para el bloque de la UCR
   dentro de INSTITUCIONES (ver datos/areas.js). */
export const AREAS_UCR_IDS = AREAS_UCR.map((a) => a.id);
